import { render, staticRenderFns } from "./jurisdiction1.vue?vue&type=template&id=622c8b60&scoped=true&"
import script from "./jurisdiction1.vue?vue&type=script&lang=js&"
export * from "./jurisdiction1.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction1.vue?vue&type=style&index=0&id=622c8b60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c8b60",
  null
  
)

export default component.exports